import gql from 'graphql-tag';

export const readAllMediaQuery = gql`
  query readAllMedia($search: String, $page: Int, $take: Int, $sortColumn: String, $sortDirection: String, $categories: [Int!]) {
    response: readAllMedium(
      search: $search
      take: $take
      page: $page
      sortColumn: $sortColumn
      sortDirection: $sortDirection,
      categories: $categories
    ) {
      total
      page
      take
      hasMore
      items {
        id
        url
        mime
        nazev
        kategorie_id
        kategorie{
          id
          nazev
        }
        created_at
      }
    }
  }
`;
